import Vue from 'vue'

export default function syncLocalStorage(store) {
  store.subscribe(({ type, payload }) => {
    const typePostfix = type.substr(-6) // make module namespace.update work
    // console.log('sync-local-storage', type, typePostfix, payload)
    switch (typePostfix) {
      case 'update':
        for (const key in payload) {
          Vue.ls.set(key, payload[key])
        }
        break
      default:
        break
    }
  })
}
